import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Injectable, Injector, runInInjectionContext } from '@angular/core';
import { AuthService } from './auth.service';
import { onAuthStateChanged } from '@angular/fire/auth';

@Injectable()
export class AuthGuard  {

  constructor(private authService: AuthService, private router: Router, private injector: Injector) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {

    const subject = new Subject<boolean>();
    runInInjectionContext(this.injector, () => {
      onAuthStateChanged(this.authService.auth, user => {
        if (!user) {
          this.router.navigate(['/login']);
          subject.next(false);
        } else {
          subject.next(true);
        }
      });
    });

    return subject;
  }
}
